import { shuffle } from '../../helpers.js';

export default {
    getAllQuestions: state => {
        return state.questions.data;
    },
    getAllQuestionsFiltered: state => {
        let data = [...state.questions.data];

        // filter by search
        const relevantQuestions = state.questions.searchResults,
              searchQuery = state.questions.searchQuery;
        if (searchQuery) {
            data = data.filter(item => relevantQuestions.indexOf(item.id) > -1);
        }

        // filter by categories
        const categories = state.questions.categoryFilter;
        if (categories.length > 0) {
            data = data.filter(item => {
                for (let i = 0; i < categories.length; i++) {
                    if (item.question_categories.indexOf(categories[i]) > -1)
                        return true;
                }
                return false;
            });
        }

        // sort by list order
        data.sort((a, b) => {
            a = a.list_order ? parseInt(a.list_order) : 0;
            b = b.list_order ? parseInt(b.list_order) : 0;
            if (a < b){
                return 1;
            }
            if (a > b){
                return -1;
            }
            return 0;
        });

        return data;
    },
    getAllCloudQuestions: state => {
        let data = [...state.questions.data];

        data = data.filter(item => item.featured);
        data.sort((a, b) => {
            a = a.cloud_order ? parseInt(a.cloud_order) : 0;
            b = b.cloud_order ? parseInt(b.cloud_order) : 0;
            if (a < b){
                return 1;
            }
            if (a > b){
                return -1;
            }
            return 0;
        });

        return data;
    },
    getSelectedQuestion: state => {
        return state.questions.data.find(item => item.slug === state.questions.selectedQuestion);
    },
    getAllQuestionCategories: state => {
        return state.questions.categories;
    },
    getQuestionCategoryFilter: state => {
        return state.questions.categoryFilter;
    },
    getQuestionsIsLoading: state => {
        return state.questions.dataLoading || state.questions.categoriesLoading;
    },
    getSearchIsLoading: state => {
        return state.questions.searchLoading;
    },
    getRelatedQuestions(state) {
        return (id, mustHave) => {
            const questions = [...state.questions.data];
            const question = questions.find(item => item.id === id);
            const questionIndex = questions.findIndex(item => item.id === id);
            let relatedQuestions = [];

            if (!question || questionIndex === -1) {
                return;
            }

            // remove current question from list
            questions.splice(questionIndex, 1);

            // add must have
            if (mustHave) {
                mustHave.forEach(id => {
                    const question = questions.find(item => item.id === id);
                    const questionIndex = questions.findIndex(item => item.id === id);
                    if (question) {
                        questions.splice(questionIndex, 1);
                        relatedQuestions.push(question);
                    }
                });
            }

            // fill up with questions from the same category
            const categories = question.question_categories;
            if (categories.length > 0) {
                const data = questions.filter(item => {
                    for (let i = 0; i < categories.length; i++) {
                        if (item.question_categories.indexOf(categories[i]) > -1)
                            return true;
                    }
                    return false;
                });
                relatedQuestions = [...relatedQuestions, ...shuffle(data)];
            }
            

            // while (relatedQuestions.length < 4) {
            //     const index = Math.floor(Math.random() * questions.length);
            //     const question = questions[index];
            //     if (question.id !== id) {
            //         questions.splice(index, 1);
            //         relatedQuestions.push(question);
            //     }
            // }

            return relatedQuestions.splice(0, 4);
        }
    },
    getQuestionsOfContributor: state => {
        let data = [...state.questions.data];
        let filtered = null;

        const contributor = state.contributors.selectedContributorForAnswers;
        if (contributor) {
            // filter by contributor
            filtered = data.filter(item => {
                for (let index = 0; index < item.statements.length; index++) {
                    const statement = item.statements[index];
                    if (statement.contributor.post_name === contributor) {
                        return true;
                    }
                }
                return false;
            });

            // sort by list order
            // filtered.sort((a, b) => {
            //     a = a.list_order ? parseInt(a.list_order) : 0;
            //     b = b.list_order ? parseInt(b.list_order) : 0;
            //     if (a < b){
            //         return 1;
            //     }
            //     if (a > b){
            //         return -1;
            //     }
            //     return 0;
            // });
        }

        return filtered;
    }

};